import isEqual from "lodash/isEqual";
import omit from "lodash/omit";
import { UniqueAlert } from "rivals/redux/alert/reducer";

export const areAlertsEqual = (
  a: Partial<UniqueAlert>,
  b: Partial<UniqueAlert>
): boolean => isEqual(omit(a, ["action", "id"]), omit(b, ["action", "id"]));
